import React from 'react';
import { Minus, Plus, RefreshCcw } from 'react-feather';

const buttonStyle = {
  backgroundColor: '#c4871b',
  borderRadius: '10px',
  padding: '5px',
  border: 'none',
  lineHeight: 0,
};

const ControlButtons = ({ onZoomIn, onZoomOut, onReset }) => {
  return (
    <div className="control-buttons">
      <button
        type="button"
        style={buttonStyle}
        onClick={onZoomOut}
        aria-label="Perkecil denah"
      >
        <Minus color="white" size={20} className="m-0" />
      </button>
      <button
        type="button"
        style={buttonStyle}
        onClick={onZoomIn}
        aria-label="Perbesar denah"
      >
        <Plus color="white" size={20} className="m-0" />
      </button>
      <button
        type="button"
        style={buttonStyle}
        onClick={onReset}
        aria-label="Kembali ke kursi saya"
      >
        <RefreshCcw color="white" size={20} className="m-0" />
      </button>
    </div>
  );
};

export default ControlButtons;
